import { useState } from 'react';
import apiConfig from '@/services/api.config';
import { FileConversionConfiguration } from 'vopay';
const { api } = apiConfig;

export default function useFetchFileConfigurations() {
  const [configurations, setConfigurations] = useState<FileConversionConfiguration[]>([]);
  const [configurationsLoading, setConfigurationsLoading] = useState(false);

  async function fetchFileConfigurations() {
    try {
      setConfigurationsLoading(true);
      setConfigurations([]);
      const res = await api.getFileConversionConfigurations();
      if (!res.Success) throw new Error(res.ErrorMessage);
      setConfigurations(res.Configurations);

      return res;
    } catch (err) {
      setConfigurations([]);
      console.error('Failed to fetch file conversion configurations:', err);

      throw err;
    } finally {
      setConfigurationsLoading(false);
    }
  }

  return {
    configurations,
    configurationsLoading,
    fetchFileConfigurations,
  };
}
